<template>
<div>
  <h4>Отсылка уведомления абонентам</h4>
  <div class="form-group">
    <label for="sms-title">Заголовок:</label>
    <input class="form-control" v-model="title" id="sms-title" />
    <label for="sms-message">Сообщение: </label>&nbsp;&nbsp;&nbsp;<span :class="color">{{message.length}}/{{maxcount}}</span>
    <textarea class="form-control" v-model="message" id="sms-message"></textarea>
  </div>

  <br>
  <button class="btn btn-secondary" @click=makeOp >Отослать</button>
</div>
</template>

<script>
  import darsan from "darsan"

  export default {
    name: "gang-send-sms",
    
    props: {
      query: String,
    },
    
    emits: [ "dismiss" ],
    
    data()
    {
      return {
        message: "",
        title: "",
      }
    },
    
    methods: {
      makeOp()
      {
        darsan
          .post("", 'client', '/gang/sms', {
            message: this.message,
            title: this.title, 
            query: this.query,
          })
          .done(res => this.common.notify(res, {}))

        this.$emit("dismiss")
      }
    },
    
    computed: {
    
      maxcount()
      {
        return /[а-яё]/i.test(this.message) ? 70 : 140
      },
    
      color() 
      {
        return this.message.length > this.maxcount ? "text-danger" : "text-success"
      },
    
    }
    
  }
</script>
